const ROUTES = {
  home: { path: "/", title: "Home", hideShadow: true },
  profile: { path: "/profile", title: "Business Account", hideShadow: true },
  login: { path: "/login", title: "Login", hideNav: true },
  register: { path: "/register", title: "Register", hideNav: true },
  resetPassword: {
    path: "/reset-password",
    title: "Reset Password",
    hideNav: true,
  },
  forgotPassword: {
    path: "/forgot-password",
    title: "Forgot Password",
    hideNav: true,
  },
  verifyOTP: { path: "/verify-otp", title: "Verify OTP", hideNav: true },

  aiChat: { path: "/ai-chat", title: "AI Chat", hideNav: false, hideShadow: true },

  help: { path: "/help", title: "Help" },

  support: { path: "/support", title: "Support" },


  supportDetails: { path: "/support-details", title: "", back: true, backPath: '/support' },

  contactUs: {
    path: "/contact-us",
    title: "Contact Us",
    backPath: "/help",
    back: true,
  },

  contactDUS: {
    path: "/contactus",
    title: "Contact Us",
    hideNav: true
  },

  customersImport: {
    path: "/customers-import",
    title: "Customers Import",
    backPath: "/customers",
    back: true,
  },

  productsImport: {
    path: "/products-import",
    title: "Products Import",
    backPath: "/manage-products",
    back: true,
  },

  analytics: { path: "/analytics", title: "Analytics", hideShadow: true },

  revenueAnalytics: {
    path: "/analytics/revenue",
    innerPath: "revenue",
    title: "Revenue",
    hideShadow: true,
    back: true,
    backPath: "/analytics",
  },

  salesAnalytics: {
    path: "/analytics/sales",
    innerPath: "sales",
    title: "Sales",
    hideShadow: true,
    back: true,
    backPath: "/analytics",
  },

  salesByStaffAnalytics: {
    path: "/analytics/sales-by-staff",
    innerPath: "sales-by-staff",
    title: "Sales By Staff",
    hideShadow: true,
    back: true,
    backPath: "/analytics",
  },

  salesByCustomerAnalytics: {
    path: "/analytics/sales-by-customer",
    innerPath: "sales-by-customer",
    title: "Sales By Customer",
    hideShadow: true,
    back: true,
    backPath: "/analytics",
  },

  paymentAnalytics: {
    path: "/analytics/payment-method",
    innerPath: "payment-method",
    title: "Payment Method",
    hideShadow: true,
    back: true,
    backPath: "/analytics",
  },

  profitsAnalytics: {
    path: "/analytics/profits",
    innerPath: "profits",
    title: "Profits",
    hideShadow: true,
    back: true,
    backPath: "/analytics",
  },

  productAnalytics: {
    path: "/analytics/products",
    innerPath: "products",
    title: "Products",
    hideShadow: true,
    back: true,
    backPath: "/analytics",
  },

  categoryAnalytics: {
    path: "/analytics/categories",
    innerPath: "categories",
    title: "Categories",
    hideShadow: true,
    back: true,
    backPath: "/analytics",
  },

  branchAnalytics: {
    path: "/analytics/branch",
    innerPath: "branch",
    title: "Branch",
    hideShadow: true,
    back: true,
    backPath: "/analytics",
  },

  settings: { path: "/settings", title: "Settings" },
  ordersSalesSettings: {
    path: "/settings/orders-sales",
    title: "Orders and Sales",
    back: true,
    backPath: "/settings",
  },
  generalSettings: {
    path: "/settings/general",
    title: "General",
    back: true,
    backPath: "/settings",
  },
  activitiesSettings: {
    path: "/settings/activities",
    title: "Account Activities",
    back: true,
    backPath: "/settings",
  },
  currencySettings: {
    path: "/settings/general/currency",
    title: "Currency",
    back: true,
    backPath: "/settings/general",
    rootPath: "/settings"
  },
  deliverySettings: {
    path: "/settings/delivery",
    title: "Delivery Rates",
    back: true,
    backPath: "/settings",
  },
  addDeliverySettings: {
    path: "/settings/delivery/add",
    title: "Add Delivery Rate",
    back: true,
    backPath: "/settings/delivery",
    rootPath: "/settings"
  },
  editDeliverySettings: {
    path: "/settings/delivery/edit",
    title: "Edit Delivery Rate",
    back: true,
    backPath: "/settings/delivery",
    rootPath: "/settings"
  },

  paymentSettings: {
    path: "/settings/payment",
    title: "Payment Options",
    back: true,
    backPath: "/settings",
  },

  myOrganization: { path: "/my-organizations", title: "My Organization" },
  addOrganization: {
    path: "/add-organization",
    title: "Add Organization",
  },
  editOrganization: {
    path: "/edit-organization",
    title: "Edit Organization",
    back: true,
    backPath: "/my-organizations",
  },
  manageBranch: {
    path: "/manage-branch",
    title: "Manage Branch",
    back: true,
    backPath: "/my-organizations",
  },
  addProduct: {
    path: "/add-product",
    title: "Add Product",
    back: true,
    backPath: "/manage-products",
    hideShadow: true,
  },
  editProduct: {
    path: "/edit-product",
    title: "Edit Product",
    back: true,
    backPath: "/manage-products",
    hideShadow: true,
  },
  manageProduct: {
    path: "/manage-products",
    title: "Manage Products",
    hideShadow: true,
  },
  checkout: { path: "/checkout", title: "Checkout", hideShadow: true },
  cart: { path: "/cart", title: "Cart", back: true, backPath: "/checkout" },
  payment: {
    path: "/payment",
    title: "Payment",
    back: true,
    backPath: "/cart",
    rootPath: "/checkout"
  },
  paymentCustomer: {
    path: "/payment-customer",
    title: "Payment Customer",
    back: true,
    backPath: "/payment",
    rootPath: "/checkout"
  },
  paymentAddCustomer: {
    path: "/add-payment-customer",
    title: "Add Payment Customer",
    back: true,
    backPath: "/payment-customer",
    rootPath: "/checkout"
  },
  saleCustomer: {
    path: "/sale-customer",
    title: "Sale Customer",
    back: true,
    backPath: "/sales-details",
    rootPath: "/sales"
  },
  saleAddCustomer: {
    path: "/add-sale-customer",
    title: "Add Sale Customer",
    back: true,
    backPath: "/sale-customer",
    rootPath: "/sales"
  },
  sales: { path: "/sales", title: "Sales" },
  salesDetails: {
    path: "/sales-details",
    title: "Sales Details",
    back: true,
    backPath: "/sales",
  },
  salesPdf: {
    path: "/sales-pdf",
    title: "Sales PDF",
    back: true,
    backPath: "/sales",
  },
  orders: { path: "/orders", title: "Orders" },
  ordersDetails: {
    path: "/orders-details",
    title: "Orders Details",
    back: true,
    backPath: "/orders",
  },
  categories: { path: "/categories", title: "Categories" },
  addCategory: {
    path: "/add-category",
    title: "Add New Category",
    back: true,
    backPath: "/categories",
  },
  editCategory: {
    path: "/edit-category",
    title: "Edit Category",
    back: true,
    backPath: "/categories",
  },
  customers: { path: "/customers", title: "Customers" },
  addCustomer: {
    path: "/add-customer",
    title: "Add New Customer",
    back: true,
    backPath: "/customers",
  },
  editCustomer: {
    path: "/edit-customer",
    title: "Edit Customer",
    back: true,
    backPath: "/customers",
  },
  customerDetails: {
    path: "/customer-details",
    title: "Customer Details",
    back: true,
    backPath: "/customers",
    hideShadow: true,
  },
  customerStoreCredit: {
    path: "/store-credit-history",
    title: "Store Credit History",
    back: true,
    backPath: "/customers",
  },
  addUser: {
    path: "/add-user",
    title: "Add User",
    back: true,
    backPath: "/manage-users",
  },
  editUser: {
    path: "/edit-user",
    title: "Edit User",
    back: true,
    backPath: "/manage-users",
  },
  addUserPassword: {
    path: "/add-user-password",
    title: "Create Password",
    back: true,
    backPath: "/add-user",
    rootPath: "/manage-users"
  },
  changeUserPassword: {
    path: "/change-user-password",
    title: "Change Password",
    back: true,
    backPath: "/user-details",
    rootPath: "/manage-users"
  },
  manageUserBranches: {
    path: "/user-details",
    title: "User Details",
    back: true,
    hideShadow: true,
    backPath: "/manage-users",
  },
  manageUser: { path: "/manage-users", title: "Manage Users" },
  upgrade: { path: "/upgrade", title: "Select Your Plan" },
  upgradeLearnMore: {
    path: "/upgrade/learn-more",
    title: "Learn More",
    back: true,
    backPath: "/upgrade",
  },
  upgradePayment: {
    path: "/upgrade/payment",
    title: "Payment",
    back: true,
    backPath: "/upgrade",
  },
};

export default ROUTES;

export const RoutesArray = Object.entries(ROUTES).map(([key, value]) => ({
  key,
  ...value,
}));
